import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

const ScrollProgress = ({ className = '' }) => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className={`fixed top-0 left-0 right-0 h-[3px] z-50 origin-left ${className}`}
      style={{
        scaleX,
        background: 'linear-gradient(90deg, #5396BD, #64B2FF, #3F6BAA)',
      }}
    />
  );
};

export default ScrollProgress;
